// extracted by mini-css-extract-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed--UBX7h","compact":"DiffLines-module__compact--wxqBo"};